import { render } from "./StageYearHit.vue?vue&type=template&id=05a81f00"
import script from "./StageYearHit.vue?vue&type=script&lang=js"
export * from "./StageYearHit.vue?vue&type=script&lang=js"

import exportComponent from "/app/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__